module.exports = __webpack_public_path__ + "static/media/ipk2022_Branding.003.e9fb87f3.jpeg";